import type { SVGProps } from 'react';

const SvgLanguage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M8.93 6.63a1 1 0 0 0-1.86 0l-4 10a.99.99 0 0 0 .56 1.3c.51.2 1.1-.04 1.3-.56L6.28 14h3.45l1.35 3.37a1.005 1.005 0 0 0 1.3.56c.51-.21.76-.79.56-1.3l-4-10zM7.08 12 8 9.69 8.92 12H7.07zM20 16c-.69 0-1.32-.2-1.88-.51 1.29-1.91 1.69-4.2 1.82-5.49H20c.55 0 1-.45 1-1s-.45-1-1-1h-1V7c0-.55-.45-1-1-1s-1 .45-1 1v1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3.92c-.12 1.07-.46 2.79-1.36 4.21-1.06-1.2-1.63-2.56-1.64-2.58a1 1 0 0 0-1.3-.55c-.51.21-.76.79-.56 1.3.05.13.75 1.83 2.14 3.32-.21.15-.42.29-.66.41-.49.25-.69.85-.45 1.34a1.007 1.007 0 0 0 1.35.44c.49-.25.93-.55 1.32-.88.91.58 1.98.99 3.23.99.55 0 1-.45 1-1s-.45-1-1-1z"
    />
  </svg>
);
export default SvgLanguage;
